module.exports = __webpack_public_path__ + "img/9788901108209.26c99820.jpg";